export const HEADER_HEIGHT = 73
